import { colors } from '../../colors';
var richText = {
  backgroundColor: colors.white,
  h1Color: colors.darkNight,
  h2Color: colors.darkNight,
  paraColor: colors.clearBlue,
  anchorColor: colors.clearBlue
};
export default richText;